import React from "react";
import { Link, useLocation } from "react-router-dom";

const PageTitle = ({ pageTitle }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Generate breadcrumb items based on the current URL path
  const breadcrumbs = pathnames.map((name, index) => {
    const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
    return {
      path: routeTo,
      label: name,
    };
  });

  const dateOptions = { weekday: 'long', day: 'numeric', month: 'short', year: 'numeric' };
  let currentDate = new Date().toLocaleDateString('en-US', dateOptions);
  // Format to "Sunday · 31 May 2026"
  currentDate = currentDate.replace(',', ' ·').replace(',', '');

  return (
    <section className="hero reveal" style={{ animationDelay: ".05s", marginBottom: "30px" }}>
      <div className="hero-grid"></div>
      <div className="hero-inner">
        <div className="hero-text">
          <div className="eyebrow">{currentDate}</div>
          <h1><span>{pageTitle || "Admin"}</span></h1>
          <p className="mb-0" style={{ display: 'flex', gap: '8px', alignItems: 'center', margin: 0 }}>
            <Link to="/admin" style={{ color: '#d9c9b6', textDecoration: 'none' }}>Admin</Link>
            {breadcrumbs.map((item, index) => {
              if (item.label.toLowerCase() === "admin") return null;
              return (
                <React.Fragment key={index}>
                  <span style={{ color: '#f1b07f' }}>/</span>
                  <Link 
                    to={item.path} 
                    style={{ 
                      color: index === breadcrumbs.length - 1 ? '#fff' : '#d9c9b6',
                      textDecoration: 'none',
                      fontWeight: index === breadcrumbs.length - 1 ? '600' : 'normal',
                      textTransform: 'capitalize'
                    }}
                  >
                    {item.label.replace(/-/g, ' ')}
                  </Link>
                </React.Fragment>
              );
            })}
          </p>
        </div>
      </div>
    </section>
  );
};

export default PageTitle;
